export default "__VITE_ASSET__c3769a99__"